import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation, WSMutationConfig } from "../../helpers";
import { patchViewNotification } from "../../../services/notifications/patchViewNotification";
import {
  QUERY_NOTIFICATIONS_NOTIFICATION,
  QUERY_NOTIFICATIONS_NOTIFICATIONS
} from "../keys";
import { WSQueryCache } from "@ws-react-query";
import { WSNotificationResponse } from "../../../modules/Dashboard/components/Notifications";

export const useViewNotification = (
  config?: WSMutationConfig<WSNotificationResponse, WSServiceError, string>
) =>
  useWSMutation((id: string) => patchViewNotification(id), {
    onSuccess: (response, id) => {
      WSQueryCache.setQueryData(
        [QUERY_NOTIFICATIONS_NOTIFICATION, id],
        response
      );
      WSQueryCache.setQueryData(QUERY_NOTIFICATIONS_NOTIFICATIONS, () => {
        return WSQueryCache.getQueryData<WSNotificationResponse[]>(
          QUERY_NOTIFICATIONS_NOTIFICATIONS
        )?.map((cachedData: WSNotificationResponse) => {
          if (cachedData.channelMessageId === id) {
            return response;
          }
          return cachedData;
        });
      });
    },
    ...config
  });
